import { render } from "./AddPromotionPage.vue?vue&type=template&id=062e93a7&ts=true"
import script from "./AddPromotionPage.vue?vue&type=script&lang=ts"
export * from "./AddPromotionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__